<template>
  <div class="device_control_page_wraper">
    <div class="close_img_top">
      <img
        src="~assets/img/controlpublic/control-guanbi-chahao.png"
        @click="$closeControlToast"
        alt
      />
    </div>
    <div class="devce_name z_ellipsis1">{{objData.remark}}</div>
    <!-- 控制内容区 -->
    <div class="content026_wraper content027_wraper">
      <!-- 三色进度条样式 -->
      <div class="data026_show data_027show">
        <!-- <span>0%</span> -->
        <progress-bar
          class="device026_hongguang_progress"
          v-on:valueChange="hongValueChange"
          :width="200"
          :maxValue="100"
          :setValue="userControlData.openState"
        >
          <span slot="sliderTitle">红光:</span>
          <!-- <span slot="sliderLeftTips">0%</span>
          <span slot="sliderRightTips">100%</span>-->
        </progress-bar>

        <progress-bar
          class="device026_lvguang_progress"
          v-on:valueChange="lvValueChange"
          :width="200"
          :maxValue="100"
          :setValue="userControlData.openStateValue"
        >
          <span slot="sliderTitle">绿光:</span>
          <!-- <span slot="sliderLeftTips">0%</span>
          <span slot="sliderRightTips">100%</span>-->
        </progress-bar>

        <progress-bar
          class="device026_languang_progress"
          v-on:valueChange="lanValueChange"
          :width="200"
          :maxValue="100"
          :setValue="userControlData.openStateValue1"
        >
          <span slot="sliderTitle">蓝光:</span>
          <!-- <span slot="sliderLeftTips">0%</span>
          <span slot="sliderRightTips">100%</span>-->
        </progress-bar>
        <!-- <span>100%</span> -->
      </div>

      <!-- 三色模式样式 -->
      <div class="device026_mode_wraper">
        <div
          class="device026_mode_text"
          :class=" userControlData.openStateValue2 === 1 ? 'device026_mode_text_active':''"
          @click="device026ModeBtnHandle(1)"
        >红光呼吸</div>
        <div
          class="device026_mode_text"
          :class=" userControlData.openStateValue2 === 2 ? 'device026_mode_text_active':''"
          @click="device026ModeBtnHandle(2)"
        >绿光呼吸</div>
        <div
          class="device026_mode_text"
          :class=" userControlData.openStateValue2 === 3 ? 'device026_mode_text_active':''"
          @click="device026ModeBtnHandle(3)"
        >蓝光呼吸</div>
        <div
          class="device026_mode_text"
          :class=" userControlData.openStateValue2 === 4 ? 'device026_mode_text_active':''"
          @click="device026ModeBtnHandle(4)"
        >三色呼吸</div>
        <div
          class="device026_mode_text"
          :class=" userControlData.openStateValue2 === 0 ? 'device026_mode_text_active':''"
          @click="device026ModeBtnHandle(0)"
        >停止呼吸</div>
      </div>
    </div>

    <!-- 开关按钮样式 -->
    <div
      class="device_026_btn device_control_btn public_control_btn"
      :class="dimming2BtnFlang? 'public_control_btn_on':''"
      @click="device026BtnClickHandle"
    >{{deviceStateComputed}}</div>
    <!-- <BUtton @click="btnhandle">按钮</BUtton> -->
  </div>
</template>

<script>
///需要注意的是  调光进度条和 按钮之间的翻转逻辑 三个进度条有一个大于0 按钮显示 已打开 三个进度条均小于等于0显示 已关闭 。同时需要把模式改成停止呼吸
//操作按钮 打开 三个进度条100 关闭 三个进度条0  同时需要把模式改成停止呼吸
///操作模式按钮 红色按钮：红色进度条100其他0 三色按钮：进度条均是100....其他逻辑详见代码
///需要注意的是打开和关闭按钮的状态是虚拟的，但是要根据实际的进度条状态进行实时状态的更新。
import { controlBtnRequestHandle } from "components/content/control-toast/control-toast-classify/device-public-js";
import {
  deviceTypeJudge,
  deviceTypeJudge1,
  publicDeviceTypeJudge,
  deviceStateFlip
} from "components/content/contro-view/device-view/device-item-view-js";
import ProgressBar from "components/common/progressbar/progress-bar";
export default {
  data() {
    return {
      userControlData: {
        ///用户设置的缓冲数据
        openState: this.objData.openState, ///红光 0-100
        openStateValue: this.objData.openStateValue, //绿光 0-100
        openStateValue1: this.objData.openStateValue1, ///蓝光 0-100
        openStateValue2: this.objData.openStateValue2 ///呼吸模式 0停止呼吸 1红色呼吸 2绿色呼吸 3蓝色呼吸 4三色呼吸
      },
      dimming2BtnFlang: 0 ///按钮的虚拟状态
    };
  },
  props: {
    objData: Object ///要控制设备的数据
  },
  components: {
    ProgressBar
  },
  methods: {
    device026BtnClickHandle() {
      ///打开关闭按钮按下
      // deviceStateFlip(this.userControlData); ///对设备的状态0和1进行翻转
      if (this.dimming2BtnFlang === 0) {
        // this.dimming2BtnFlang =1 ;
        this.userControlData.openStateValue2 = 0; ///停止呼吸模式下，才可以进行单独的控制
        this.userControlData.openState = 100;
        this.userControlData.openStateValue = 100;
        this.userControlData.openStateValue1 = 100;
      } else {
        this.userControlData.openStateValue2 = 0; ///停止呼吸模式下，才可以进行单独的控制
        this.userControlData.openState = 0;
        this.userControlData.openStateValue = 0;
        this.userControlData.openStateValue1 = 0;
      }

      controlBtnRequestHandle(this.userControlData, this.objData); ///控制请求服务端的公共方法
    },
    hongValueChange(data) {
      ///红光进度条值改变
      console.log("子组件传回的值" + data);
      if (this.userControlData.openState === data) return;
      this.userControlData.openState = data;
      this.userControlData.openStateValue2 = 0; ///停止呼吸模式下，才可以进行单独的控制
      controlBtnRequestHandle(this.userControlData, this.objData); ///控制请求服务端的公共方法
    },
    lvValueChange(data) {
      ///绿光进度条值改变
      console.log("子组件传回的值" + data);
      if (this.userControlData.openStateValue === data) return;
      this.userControlData.openStateValue = data;
      this.userControlData.openStateValue2 = 0; ///停止呼吸模式下，才可以进行单独的控制
      controlBtnRequestHandle(this.userControlData, this.objData); ///控制请求服务端的公共方法
    },
    lanValueChange(data) {
      ///蓝光进度条值改变
      console.log("子组件传回的值" + data);
      if (this.userControlData.openStateValue1 === data) return;
      this.userControlData.openStateValue1 = data;
      this.userControlData.openStateValue2 = 0; ///停止呼吸模式下，才可以进行单独的控制
      controlBtnRequestHandle(this.userControlData, this.objData); ///控制请求服务端的公共方法
    },
    device026ModeBtnHandle(mode) {
      ////呼吸模式按钮按下了
      if (mode === 1) {
        //红光呼吸按钮
        this.userControlData.openState = 100; //红光
        this.userControlData.openStateValue = 0; //绿光
        this.userControlData.openStateValue1 = 0; ///蓝光
      } else if (mode === 2) {
        //绿光呼吸按钮
        this.userControlData.openState = 0; //红光
        this.userControlData.openStateValue = 100; //绿光
        this.userControlData.openStateValue1 = 0; ///蓝光
      } else if (mode === 3) {
        //蓝光呼吸按钮
        this.userControlData.openState = 0; //红光
        this.userControlData.openStateValue = 0; //绿光
        this.userControlData.openStateValue1 = 100; ///蓝光
      } else if (mode === 4) {
        //三色呼吸按钮
        this.userControlData.openState = 100; //红光
        this.userControlData.openStateValue = 100; //绿光
        this.userControlData.openStateValue1 = 100; ///蓝光
      } else if (mode === 0) {
        //停止呼吸按钮
        this.userControlData.openState = 0; //红光
        this.userControlData.openStateValue = 0; //绿光
        this.userControlData.openStateValue1 = 0; ///蓝光
      }
      this.userControlData.openStateValue2 = mode;
      controlBtnRequestHandle(this.userControlData, this.objData); ///控制请求服务端的公共方法
    }
    // btnhandle() {
    //   this.userControlData.openStateValue++;
    // }
  },
  computed: {
    deviceStateComputed() {
      // ////虚拟打开关闭按钮的实时状态更新
      if (
        this.userControlData.openState <= 0 &&
        this.userControlData.openStateValue <= 0 &&
        this.userControlData.openStateValue1 <= 0
      ) {
        this.dimming2BtnFlang = 0;
        console.log("打开关闭属性已计算 0");
        return "已关闭";
      } else {
        this.dimming2BtnFlang = 1;
        console.log("打开关闭属性已计算 1");
        return "已打开";
      }
    }
  },
  watch: {
    "objData.openState": {
      // deep:true,
      handler: function(val) {
        ///保证服务器数据和用户设置的数据同步
        console.log(val);
        this.userControlData.openState = val;
      }
    },
    "objData.openStateValue": {
      // deep:true,
      handler: function(val) {
        ///保证服务器数据和用户设置的数据同步
        console.log(val);
        this.userControlData.openStateValue = val;
      }
    },
    "objData.openStateValue1": {
      // deep:true,
      handler: function(val) {
        ///保证服务器数据和用户设置的数据同步
        console.log(val);
        this.userControlData.openStateValue1 = val;
      }
    },
    "objData.openStateValue2": {
      // deep:true,
      handler: function(val) {
        ///保证服务器数据和用户设置的数据同步
        console.log(val);
        this.userControlData.openStateValue2 = val;
      }
    }
  }
};
</script>

<style>
.content026_wraper {
  height: 360px;
}
.data026_show {
  /* margin-top: 20px; */
  margin-bottom: 60px;
  position: relative;
}
.device026_hongguang_progress {
  position: absolute;
  left: 50px;
  top: -5px;
}
.device026_lvguang_progress {
  position: absolute;
  left: 50px;
  top: 65px;
}
.device026_languang_progress {
  position: absolute;
  left: 50px;
  top: 135px;
}
.device_026_btn {
  width: 90%;
  margin-top: 0px;
  margin-bottom: 0px;
}

/* 三色模式样式 */
.device026_mode_wraper {
  width: 100%;
  height: 120px;
  position: absolute;
  top: 300px;

  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  justify-content: space-around;
  align-items: center;
}
.device026_mode_text {
  width: 75px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  border: 1px solid var(--control-outline-color);
  border-radius: 4px;

  font-size: 14px;
  color: #f5f5f5;
}
.device026_mode_text_active {
  background-color: #f5f5f5;
  color: #282828;
}
</style>
